import { render, staticRenderFns } from "./loginPassword.vue?vue&type=template&id=5a3573d4&scoped=true"
import script from "./loginPassword.vue?vue&type=script&lang=js"
export * from "./loginPassword.vue?vue&type=script&lang=js"
import style0 from "./loginPassword.vue?vue&type=style&index=0&id=5a3573d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3573d4",
  null
  
)

export default component.exports